import {
  GET_DEPARTMENT,
  SHOW_DEPARTMENT,
  CREATE_DEPARTMENT,
  EDIT_DEPARTMENT,
  DELETE_DEPARTMENT
} from "@/store/modules/mutation-types";

export default {
  state: {},
  getters: {},
  actions: {
    async [GET_DEPARTMENT]({ dispatch }, params) {
      const res = await dispatch("apiGet", {
        url: "/kanri/departments",
        data: params.data
      });
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        };
      }
      return res.data;
    },
    async [SHOW_DEPARTMENT]({ dispatch }, params) {
      let url = "/kanri/departments/" + params.id;
      const res = await dispatch("apiGet", {
        url: url,
        data: params.data
      });
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        };
      }
      return res.data;
    },
    async [CREATE_DEPARTMENT]({ dispatch }, params) {
      const res = await dispatch("apiPost", {
        url: "/kanri/departments",
        data: params.data
      });
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        };
      }
      return res.data;
    },
    async [EDIT_DEPARTMENT]({ dispatch }, params) {
      let url = "/kanri/departments/" + params.id;
      const res = await dispatch("apiPatch", {
        url: url,
        data: params.data
      });
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        };
      }
      return res.data;
    },
    async [DELETE_DEPARTMENT]({ dispatch }, params) {
      let url = "/kanri/departments/" + params.id;
      const res = await dispatch("apiDelete", {
        url: url,
        data: params.data
      });
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        };
      }
      return res.data;
    }
  },
  mutations: {}
};
